import React, { forwardRef, useState } from 'react';
import { v4 } from 'uuid';
import { Chart } from 'components/shared/Chart';
import { useDeviceChartMarker, useDeviceTimeSeriesChart } from '../../hooks';
import { DeviceChartLegend } from '../DeviceChartLegend';
import { DeviceChartMarkerDialog } from '../DeviceChartMarkerDialog';
import { DeviceChartMarkerPopup } from '../DeviceChartMarkerPopup';
import styles from './DeviceTimeSeriesChart.module.css';

const DeviceTimeSeriesChart = forwardRef(function DeviceTimeSeriesChart(
  {
    title,
    height,
    data,
    datasets,
    scales,
    actionAnnotations,
    userAnnotations,
    actionsLoading,
    actionsEnabled,
    actionsVisible,
    enabledZoom,
    enabledMarker,
    displayAxisTitle,
    displayActionAnnotation,
    displayUserAnnotation,
    displayDataLabel,
    displayMarker,
    onClickActionVisible,
    onCreateAnnotation,
    onUpdateAnnotation,
    onDeleteAnnotation,
    onZoomComplete,
    onMarkerPlaceEnd: _onMarkerPlaceEnd,
    onMarkerPlaceCancel,
    onResize
  },
  forwardedRef
) {
  const [id] = useState(() => v4());
  const { ref, onMarkerHover, onMarkerDragEnd, onMarkerPlaceEnd, dialog, popup } = useDeviceChartMarker(
    {
      onCreate: onCreateAnnotation,
      onUpdate: onUpdateAnnotation,
      onDelete: onDeleteAnnotation,
      onMarkerPlaceEnd: _onMarkerPlaceEnd
    },
    forwardedRef
  );
  const chart = useDeviceTimeSeriesChart({
    data,
    datasets,
    scales,
    actionAnnotations,
    userAnnotations,
    enabledZoom,
    enabledMarker,
    displayAxisTitle,
    displayActionAnnotation,
    displayUserAnnotation,
    displayDataLabel,
    displayMarker,
    onZoomComplete,
    onMarkerPlaceEnd,
    onMarkerPlaceCancel,
    onMarkerHover,
    onMarkerDragEnd,
    onResize
  });

  return (
    <div className={styles.root}>
      <div className={styles.chart} style={{ height: height && `${height}px` }}>
        <Chart ref={ref} id={id} role="img" aria-label={title} {...chart} />
      </div>
      <DeviceChartLegend
        htmlFor={id}
        datasets={datasets}
        actionsLoading={actionsLoading}
        actionAnnotations={actionAnnotations}
        rebootAvailable={actionsEnabled}
        rebootVisible={actionsVisible}
        onClickRebootVisible={onClickActionVisible}
      />
      <DeviceChartMarkerPopup {...popup} />
      <DeviceChartMarkerDialog {...dialog} />
    </div>
  );
});

export { DeviceTimeSeriesChart };
